import axios from 'axios';
import i18n from '../i18n';
import authHeader from './auth-header';
import * as _ from 'lodash';

const NODE_ENV = process.env.NODE_ENV;
const PROTOCOL = process.env.PROTOCOL || 'http://';
const END_POINT_URL = process.env.END_POINT_URL || window.location.hostname;
const END_POINT_PORT = process.env.END_POINT_PORT || '8080';

const API_URL = NODE_ENV === 'production' ? PROTOCOL + END_POINT_URL + '/api/auth/' : PROTOCOL + END_POINT_URL + ':' + END_POINT_PORT + '/api/auth/';

class AuthService {
  login(user) {
    return axios
      .post(API_URL + 'signin', {
        username: _.trim(user.username),
        password: user.password,
        force: user.force || false
      },
      {
        "Access-Control-Allow-Origin": `*`
      }
    )
      .then((response) => {
        if (response.data.accessToken) {
          if (response.data.language)
            i18n.locale = response.data.language;
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }

  logout() {
    return axios.put(API_URL + 'logout')
  }

  register(user) {
    return axios.post(API_URL + 'signup', {
      username: user.username,
      password: user.password,
    });
  }

  forgotPassword(user) {
    return axios.put(API_URL + 'reset-password', user);
  }

  updatePassword(user,token){
    return axios.put(API_URL + 'update-password/' + token, user);
  }

  saveUserHistory(userHistory){
    return axios.post(API_URL + 'user-history/', userHistory);
  }

}

export default new AuthService();



// WEBPACK FOOTER //
// ./src/services/auth.service.js